import React from 'react';
import SocialBtns from '../../components/SocialBtns';
import MenuWidget from '../Widget/MenuWidget';
import NewsLetterWidget from '../Widget/NewsLetterWidget';
const menuDataOne = [
  { title: 'About', href: '/about' },
  { title: 'Projects', href: '/projects' },
  { title: 'Services', href: '/service' },
  { title: 'Contact', href: '/contact' },
];
export default function Footer() {
  return (
    <footer
      className="cs_footer background-filled text-white"
      style={{ backgroundColor: '#463b2c' }}
    >
      <div className="container">
        <div className="cs_footer_top d-flex justify-content-between align-items-start align-items-md-center cs_pt_46 cs_pb_46 cs_column_gap_15 cs_row_gap_15 flex-md-row  flex-column">
          <div className="cs_footer_contact_info">
            <h3 className="text-accent fw-normal cs_mb_4 cs_fs_16 cs_lh_lg">
              Have Any Question?
            </h3>
            <h2 className="text-white fw-medium m-0 cs_fs_22">
              +1 (281) 409 5882
            </h2>
          </div>
          <div className="cs_footer_logo">
            <img src="/images/logo white.png" alt="Logo" loading="lazy" decoding="async" />
          </div>
          <div className="cs_footer_contact_info">
            <h3 className="text-accent fw-normal cs_mb_4 cs_fs_16 cs_lh_lg">
              Send Email
            </h3>
            <h2 className="text-white fw-medium m-0 cs_fs_22">
              <a href="mailto:manager@hybridonecarpentry.com">manager@hybridonecarpentry.com</a>
            </h2>
          </div>
        </div>
        <div className="cs_footer_main cs_pt_30 cs_pb_30">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item cs_pt_20 cs_pb_20">
                <div className="cs_text_widget">
                  <p>7322 Southwest Freeway, Arena Tower One, Suite 140</p>
                  <p>Houston, TX 77074</p>
                  <p>
                    Website:{' '}
                    <a href="https://hybridonecarpentry.com/" target="_blank" rel="noreferrer">
                      hybridonecarpentry.com
                    </a>
                  </p>
                </div>
                <SocialBtns variant="cs_social_btns d-flex flex-wrap cs_column_gap_15 cs_row_gap_15 cs_transition_5" />
              </div>
            </div>
            <div className="col-lg-4 offset-lg-1">
              <MenuWidget data={menuDataOne} title="Explore" />
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item cs_pt_20 cs_pb_20">
                <NewsLetterWidget
                  title="Stay Updated"
                  subTitle="Subscribe for project showcases, woodwork tips, and exclusive offers."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_copyright text-center cs_fs_124 cs_lh_lg cs_pt_12 cs_pb_12">
        <div className="container">
          <p className="m-0">
            Copyright © 2023 Hybrid One Carpentry | All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
